var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5625_8230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.95801 2.62012H2.16634C1.87902 2.62012 1.60347 2.73425 1.40031 2.93742C1.19714 3.14058 1.08301 3.41613 1.08301 3.70345V11.2868C1.08301 11.5741 1.19714 11.8497 1.40031 12.0528C1.60347 12.256 1.87902 12.3701 2.16634 12.3701H9.74967C10.037 12.3701 10.3125 12.256 10.5157 12.0528C10.7189 11.8497 10.833 11.5741 10.833 11.2868V7.49512",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0205 1.80725C10.236 1.59176 10.5283 1.4707 10.833 1.4707C11.1378 1.4707 11.43 1.59176 11.6455 1.80725C11.861 2.02274 11.9821 2.31501 11.9821 2.61975C11.9821 2.9245 11.861 3.21676 11.6455 3.43225L6.49967 8.57809L4.33301 9.11975L4.87467 6.95309L10.0205 1.80725Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5625_8230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0 0.454102)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9e054494b49c9c635213e6ca77630343.svg";
export { ForwardRef as ReactComponent };